import { buildDeepLinkQuery, type NavigationContext } from '@aegislab/shared';
import { useWindowStore } from './windowStore';

/** 「캠페인 성과급」 창의 id. 창이 앱에 등록되기 전에는 이 id 를 여는 링크를 그리지 않는다. */
export const CAMPAIGN_BONUS_WINDOW_ID = 'campaign-bonus';

export interface CampaignBonusDestination {
  tab: NonNullable<NavigationContext['campaignBonusTab']>;
  scenarioId: string;
}

function campaignBonusContext({ tab, scenarioId }: CampaignBonusDestination): NavigationContext {
  return { campaignBonusTab: tab, scenarioId };
}

export function buildCampaignBonusHref(destination: CampaignBonusDestination) {
  const query = buildDeepLinkQuery(CAMPAIGN_BONUS_WINDOW_ID, campaignBonusContext(destination));
  return `/?${new URLSearchParams(query)}`;
}

export function openCampaignBonus(destination: CampaignBonusDestination) {
  useWindowStore.getState().openWindow(CAMPAIGN_BONUS_WINDOW_ID, campaignBonusContext(destination));
}
